class WCDetails extends WCDummy {
  #details;

  constructor() {
    super({ tag: WCDetails.tag });

    if (this.animate || !this.multi) {
      this.#details = Array.from(this.querySelectorAll("details")).map(
        (detail) => ({
          node: detail,
          animation: null,
        })
      );

      this.handleClick = this.handleClick.bind(this);
    }
  }

  static get tag() {
    return "wc-details";
  }

  connectedCallback() {
    if (this.animate || !this.multi) {
      this.#details.forEach(({ node }) => {
        node
          .querySelector("summary")
          .addEventListener("click", this.handleClick);
      });
    }
  }

  disconnectedCallback() {
    if (this.animate || !this.multi) {
      this.#details.forEach(({ node }) => {
        node
          .querySelector("summary")
          .removeEventListener("click", this.handleClick);
      });
    }
  }

  attributeChangedCallback(name, oldValue, newValue) {
    switch (name) {
      case "lock":
        break;
    }
  }

  get animate() {
    return this.getAttribute("animate") !== "false";
  }

  get multi() {
    return this.hasAttribute("multi");
  }

  #open({ node, animation }) {
    node.style.overflow = "hidden";
    node.style.height = `${node.offsetHeight}px`;
    node.setAttribute("open", "");

    animation.keyframes = {
      height: [
        `${node.offsetHeight}px`,
        `${
          node.querySelector("summary").offsetHeight +
          node.querySelector("summary + *").offsetHeight
        }px`,
      ],
    };
    animation.onFinish = () => {
      node.style.height = node.style.overflow = "";
    };
    animation.onCancel = () => {
      node.removeAttribute("open");
    };
    animation.animate();
  }

  #close({ node, animation }) {
    node.style.overflow = "hidden";

    animation.keyframes = {
      height: [
        `${node.offsetHeight}px`,
        `${node.querySelector("summary").offsetHeight}px`,
      ],
    };
    animation.onFinish = () => {
      node.style.height = node.style.overflow = "";
      node.removeAttribute("open");
    };
    animation.animate();
  }

  handleClick(e) {
    e.preventDefault();
    if (this.animate) {
      const options = {
        duration: 400,
        easing: "ease-in-out",
      };
      this.#details.forEach((detail) => {
        const found = e.currentTarget.isEqualNode(
          detail.node.querySelector("summary")
        );
        if (!detail.animation) {
          detail.animation = new Animation();
          detail.animation.options = options;
          detail.animation.node = detail.node;
        }
        if (!this.multi) {
          if (detail.node.hasAttribute("open")) {
            this.#close(detail);
          } else if (found && !detail.node.hasAttribute("open")) {
            this.#open(detail);
          }
        } else if (found) {
          if (detail.node.hasAttribute("open")) {
            this.#close(detail);
          } else if (found && !detail.node.hasAttribute("open")) {
            this.#open(detail);
          }
        }
      });
    } else {
      this.#details.forEach((detail) => {
        const found = e.currentTarget.isEqualNode(
          detail.node.querySelector("summary")
        );
        if (!this.multi) {
          if (detail.node.hasAttribute("open")) {
            detail.node.removeAttribute("open");
          } else if (found && !detail.node.hasAttribute("open")) {
            detail.node.setAttribute("open", "");
          }
        } else if (found) {
          if (detail.node.hasAttribute("open")) {
            detail.node.removeAttribute("open");
          } else if (found && !detail.node.hasAttribute("open")) {
            detail.node.setAttribute("open", "");
          }
        }
      });
    }
  }
}
customElements.define(WCDetails.tag, WCDetails);
